import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';

@Component({
  standalone: true,
  selector: 'app-chip-renderer',
  templateUrl: './ag-chip-renderer.component.html',
  styleUrls: ['./ag-chip-renderer.component.scss'],
  imports: [CommonModule]
})
export class AgChipRendererComponent implements AgRendererComponent {
  params: any;
  styleClass = "";

  agInit(params: any): void {
    this.params = params;
    if (params?.value) {
      this.styleClass = params?.value?.toLowerCase().replace(" ", "");
    }
  }

  refresh(params: any): boolean {
    return false;
  }
}
